import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormTextField from '../form/FormTextField';
import QuestionHeader from './QuestionHeader';
import { Typography } from '@material-ui/core';

const SubmissionFreeText = ({ name, number, questionText, placeholder, readonly, isOptional }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary">Odpowiedź nie jest wymagana</Typography>}
      <div>
        <Field
          name={`${name}.answerText`}
          component={FormTextField}
          placeholder={placeholder}
          fullWidth
          disabled={readonly}
          inputProps={{ 'aria-label': questionText }}
          multiline
          rows={1}
          rowsMax={Infinity}
        />
      </div>
    </div>
  </div>
);

SubmissionFreeText.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
};

export default SubmissionFreeText;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionFreeText.js